import { CAN_RESET_DISTRIBUTION_BID_IN_PROCESS_STATUS_KEY } from "constants/localStorage";
import { clearLocalStorage } from "helpers/localStorage";
import { paths } from "helpers/paths";
import moment from "moment";
import { refreshToken as refreshTokenReq } from "services/request";
import { logout } from "sources/account";

const create = () => {
    const storedToken = localStorage.getItem("token");
    const storedCurrentUser = localStorage.getItem("currentUser");
    const tokenExpiresIn = localStorage.getItem("tokenExpiresIn");
    const refreshToken = localStorage.getItem("refreshToken");
    if (storedToken && storedCurrentUser && tokenExpiresIn && refreshToken) {
        if (moment(tokenExpiresIn) > moment()) {
            return Promise.resolve({ token: storedToken, currentUser: JSON.parse(storedCurrentUser) });
        } else {
            return refreshTokenReq().catch(() => {
                clearLocalStorage();
                window.location.reload();
            });
        }
    } else {
        return Promise.reject(new Error());
    }
};

const del = () => {
    const token = localStorage.getItem("techUserToken");
    const refreshToken = localStorage.getItem("techUserRefreshToken");
    const tokenExpiresIn = localStorage.getItem("techUserTokenExpiresIn");
    const currentUser = localStorage.getItem("techUserCurrentUser");

    if (token && refreshToken && tokenExpiresIn && currentUser) {
        localStorage.setItem("token", token);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("tokenExpiresIn", tokenExpiresIn);
        localStorage.setItem("currentUser", currentUser);

        localStorage.removeItem("isTechSupport");
        localStorage.removeItem("techUserToken");
        localStorage.removeItem("techUserRefreshToken");
        localStorage.removeItem("techUserTokenExpiresIn");
        localStorage.removeItem("techUserCurrentUser");
        localStorage.removeItem("canManageOrganization");
        localStorage.removeItem(CAN_RESET_DISTRIBUTION_BID_IN_PROCESS_STATUS_KEY);

        window.location.href = paths.adminUsers;
    } else {
        logout().then(() => {
            clearLocalStorage();
            window.location.replace(paths.domain);
        });
    }
};

const licenseExpired = () => {
    window.location.href = "/license-expired";
    return false;
};

export { create, del, licenseExpired };
